import { Workflow } from 'lucide-react';
import { textoLivre } from '../../nucleo/formato';
import { caminhoDaAba, type FonteBuscaGlobal } from '../../nucleo/modulos-web';
import { BASE_FLUXOS } from './tipos-fluxos';

/**
 * Review rl30-1 (spec B2, lista de 30/10 item 10): automações de conversa (pelo nome, a busca da aba Automações, que lê
 * `?busca=`). O item abre o editor do fluxo.
 */
interface FluxoBusca {
  id: string;
  nome: string;
}

const lista = (busca: string) => `${caminhoDaAba('automacoes', 'fluxos')}?busca=${encodeURIComponent(busca)}`;

export const buscaAutomacoes: FonteBuscaGlobal[] = [
  {
    chave: 'fluxos',
    permissao: 'automacoes.ver',
    pagina: 'automacoes.fluxos',
    grupo: 'buscaGlobal.fluxos',
    posicao: 98,
    icone: Workflow,
    item: (f: FluxoBusca) => ({ id: f.id, rotulo: textoLivre(f.nome), link: `${BASE_FLUXOS}/fluxo/${f.id}` }),
    verTodos: lista,
  },
];
